// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__0otRP","rotate":"Spinner_rotate__XUtTQ","spinner__hero":"Spinner_spinner__hero__XLgeH","spinner__realm":"Spinner_spinner__realm__wDhXS"};